import { render, staticRenderFns } from "./CustomerListPage.vue?vue&type=template&id=78ebaccb&scoped=true"
import script from "./CustomerListPage.vue?vue&type=script&lang=js"
export * from "./CustomerListPage.vue?vue&type=script&lang=js"
import style0 from "./CustomerListPage.vue?vue&type=style&index=0&id=78ebaccb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ebaccb",
  null
  
)

export default component.exports